import { CampaignStatus } from '~/generated/graphql'
import { DateTime } from 'luxon'

export const isApproved = (status: CampaignStatus) => status === CampaignStatus.Approved

export const isApprovalRequest = (status: CampaignStatus) => status === CampaignStatus.ApprovalRequest

export const isRevisionRequired = (status: CampaignStatus) => status === CampaignStatus.RevisionRequired

export const isFinish = (status: CampaignStatus) => status === CampaignStatus.Finish

export const isDenial = (status: CampaignStatus) => status === CampaignStatus.Denial

export const isNotApproved = (status: CampaignStatus) => {
  const unapprovedStatuses: CampaignStatus[] = [
    CampaignStatus.ApprovalRequest,
    CampaignStatus.Denial,
    CampaignStatus.Finish,
    CampaignStatus.RevisionRequired,
  ]
  return unapprovedStatuses.includes(status)
}

export const isNotRevisionRequired = (status: CampaignStatus) => {
  const unRevisionRequiredStatuses: CampaignStatus[] = [
    CampaignStatus.ApprovalRequest,
    CampaignStatus.Denial,
    CampaignStatus.Finish,
    CampaignStatus.Approved,
  ]
  return unRevisionRequiredStatuses.includes(status)
}

export const isPublished = (status: CampaignStatus) => {
  const publishedStatuses: CampaignStatus[] = [CampaignStatus.Approved, CampaignStatus.Finish]
  return publishedStatuses.includes(status)
}

// 公開待機中
export const isWaitingForPublication = (
  status: CampaignStatus,
  offerStarted: string | null,
  now: DateTime,
): boolean => {
  if (status !== CampaignStatus.Approved) return false
  if (!offerStarted) return false

  const scheduled = DateTime.fromISO(offerStarted)
  return now < scheduled
}
